
import { AdminLogin } from "@/components/admin/AdminLogin";

export function AdminLoginPage() {
  return <AdminLogin />;
}
